//for ppt, link to google drive
//for pdf any link is ok

export const units = {
  u_001:{
    title: "Course Curriculum",
    description:"",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/01_CourseCurriculum.pdf",
      header: null,
      footer: null
    }
  },u_002:{
    title: "Student Assessement framework",
    description:"",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/02_StudentAssessment.pdf",
      header: null,
      footer: null
    }
  },u_003:{
    title: "Orientation PPT",
    description:"",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://www.youtube.com/embed/UBm8e3kbXSI",
      header: null,
      footer: null
    }
  },u_004:{
    title: "Audit Report",
    description:"Summary of the last audit carried out in the university. Contains audit framework and the audit status in a snapshot.",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/04_Audit-Report_Summary.pdf",
      header: null,
      footer: null
    }
   },u_005:{
    title: "Four foundational facilitation practice",
    description:"A quick reference on how to get started and what to do differently in your sessions as a facilitator",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/05_FourBasicFacPractices.pdf",
      header: null,
      footer: null
    }
   },u_006:{
    title: "Unit 1: Who is a Contributor::Detailed process guide",
    description:"Guidelines on how you could run each session of the unit and what to focus on in each exercise.",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/06_FacGuide_unit_01.pdf",
      header: null,
      footer: null
    }
   },u_007:{
    title: "Unit 7: Design Solutions",
    description:"Includes guides for design exercise 7.2.2, 7.2.3, 7.2.4 and 7.3.3",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/07_Unit+7+Design+Guides.pdf",
      header: null,
      footer: null
    }
  },u_008:{
    title: "Unit 8: Focus on Value",
    description:"Includes guides for design exercise 8.2.1, 8.2.2, 8.2.3, 8.2.4, 8.3.2 and 8.3.3",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/08_Unit+8+Design+Guides.pdf",
      header: null,
      footer: null
    }
  },u_009:{
    title: "Unit 9: Engage Deeply",
    description:"Includes guides for design exercise 9.2.2, 9.2.4, 9.3.1 B, 9.3.4",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/09_Unit+9+Design+Guides.pdf",
      header: null,
      footer: null
    }
  },u_010:{
    title: "What is solution thinking",
    description:"How is solution thinking different from process thinking or problem solving? What does solution thinking allow for, which other modes of thinking do not? Find answers to some such questions.",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/010_WhatSolnThink.pdf",
      header: null,
      footer: null
    }
  },u_011:{
    title: "Applying solution thinking",
    description:"What is ‘solutioning’ mode of thinking? Why is this mode of thinking so crucial? Where it gets applied? Explore these questions.",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/011_ApplySolnThink.pdf",
      header: null,
      footer: null
    }
  },u_012:{
    title: "What is imaginative sympathy",
    description:"This note discusses the three foundational practices of operating with imaginative sympathy. In addition, it also explores the question of how is imaginative sympathy different from personal sympathy on one hand and impersonal vision/ planning of the other.",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/012_ImaginativeSympathy.pdf",
      header: null,
      footer: null
    }
  },u_013:{
    title: "Callousness is born in the absence of imaginative sympathy",
    description:"A direct consequence of lack of the imaginative sympathy is contraction of the self and callousness – A perspective note to help you appreciate this",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://s3.ap-south-1.amazonaws.com/facultyresource/contributir/013_CallousnsImagSym.pdf",
      header: null,
      footer: null
    }
  },u_014:{
    title: "How our identity shapes us",
    description:"What is the link between our identity and behavior? Read up on this in this write-up.",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://www.youtube.com/embed/UBm8e3kbXSI",
      header: null,
      footer: null
    }
  },u_015:{
    title: "How is identity born",
    description:"How infusing meaning and purpose into the work can invoke our dynamic identity. Watch this video to gain an appreciation into this. (~4 min)",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"video",
      link:"https://www.youtube.com/watch?v=3jcAWfPW7fk",
      header: null,
      footer: null
    }
  },u_016:{
    title: "Importance of dynamic identity",
    description:"What happens when we operate with a static identity? How does dynamic identity lend flexibility? Here is a write-up to help you gain insight into the workings of static and dynamic identity.",
    icon: "https://wwwcdn.howdesign.com/wp-content/uploads/icons.jpg",
    post: {
      type:"pdf",
      link:"https://www.youtube.com/embed/UBm8e3kbXSI",
      header: null,
      footer: null
    }
  },
}

Object.keys(units).forEach((key, i)=>{
  units[key].route = "/application/unit/"+key
});


// WEBPACK FOOTER //
// ./src/modal/units.js